import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack mb-6" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = {
  id: "ibo_user_toggle_link",
  class: "btn btn-link",
  "data-bs-toggle": "collapse",
  href: "#ibo_user_toggle"
}
const _hoisted_4 = { class: "fw-bolder" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Group Users ")
const _hoisted_6 = { class: "fs-6 text-gray-400 fw-bolder ms-1" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("(")
const _hoisted_8 = { class: "text-gray" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_10 = {
  href: "#",
  class: "btn btn-sm btn-success p-1 pe-4",
  "data-bs-toggle": "modal",
  "data-bs-target": "#add_user_modal"
}
const _hoisted_11 = { class: "svg-icon svg-icon-1qh" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fs-9" }, "New User", -1)
const _hoisted_13 = {
  class: "row g-6 collapse",
  id: "ibo_user_toggle"
}
const _hoisted_14 = { class: "row g-6 mt-10" }
const _hoisted_15 = { class: "fw-bolder" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" IBO Users ")
const _hoisted_17 = { class: "fs-6 text-gray-400 fw-bolder ms-1" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("(")
const _hoisted_19 = { class: "text-gray" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(")")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Card3 = _resolveComponent("Card3")!
  const _component_AddUserModal = _resolveComponent("AddUserModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.groupUsersMeta.total), 1),
              _hoisted_9
            ])
          ])
        ])
      ]),
      _createElementVNode("a", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
        ]),
        _hoisted_12
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupUsers, (user, index) => {
        return (_openBlock(), _createBlock(_component_Card3, {
          key: index,
          name: user.adminfullname,
          position: user.username,
          online: true,
          loginStatus: user.loginstatus,
          initials: user.adminfullname.charAt(0),
          connected: true,
          "avg-earnings": "$14,560",
          "total-sales": "$236,400"
        }, null, 8, ["name", "position", "loginStatus", "initials"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("h3", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("span", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.groupUsersMeta2.total), 1),
          _hoisted_20
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupUsers2, (user, index) => {
        return (_openBlock(), _createBlock(_component_Card3, {
          key: index,
          name: user.adminfullname,
          position: user.username,
          online: true,
          loginStatus: user.loginstatus,
          initials: user.adminfullname.charAt(0),
          connected: true,
          "avg-earnings": "$14,560",
          "total-sales": "$236,400"
        }, null, 8, ["name", "position", "loginStatus", "initials"]))
      }), 128))
    ]),
    _createVNode(_component_AddUserModal, { onSubmit: _ctx.onAddUser }, null, 8, ["onSubmit"])
  ], 64))
}